const newProduct = {
  getNewProductDashBoard: {
    type: 'get',
    url: `/ec-pc-api/arrival/dashboard`
  },
  getNewProductRemarkList: {
    type: 'post',
    url: `/ec-pc-api/arrival/remark/list`
  },
  addNewProductRemark: {
    type: 'post',
    url: `/ec-pc-api/arrival/remark/add`
  },
  modifyNewProductRemark: {
    type: 'post',
    url: `/ec-pc-api/arrival/remark/update`
  },
  getProcessList: {
    type: 'get',
    url: `/ec-pc-api/arrival/process/list`
  },
  getProductList: {
    type: 'post',
    url: `/ec-pc-api/arrival/list`
  },
  getProductDiagram: {
    type: 'get',
    url: `/ec-pc-api/arrival/info`
  },
  getProductOperate: {
    type: 'post',
    url: `/ec-pc-api/arrival/operate`
  },
  getSkuInfo: {
    type: 'get',
    url: `/ec-pc-api/arrival/skuInfo`
  },
  delNewProduct: {
    type: 'get',
    url: `/ec-pc-api/arrival/del`
  },
  renameSku: {
    type: 'get',
    url: `/ec-pc-api/arrival/sku/rename`
  },
  modifyTimeOrRemark: {
    type: 'post',
    url: `/ec-pc-api/arrival/time2remark`
  },
  getPhotoBatchCode: {
    type: 'get',
    url: `/ec-pc-api/arrival/photoBatchCode`
  },
  getProductEnum: {
    type: 'get',
    url: `/ec-pc-api/arrival/enum`
  },
  upDataImg: {
    type: 'post',
    url: `/ec-pc-api/arrival/upload/newProductImg`
  },
  getProductAlter: {
    type: 'post',
    url: `/ec-pc-api/arrival/alter`
  },
  checkTheDetails: {
    type: 'get',
    url: `/ec-pc-api/customize/columns`
  },
  customizeColumnsNew: {
    type: 'get',
    url: `/ec-goods-new-api/customize/columns`
  },
  getNewProductReport: {
    type: 'post',
    url: `/ec-pc-api/arrival/productReport`
  },
  getNodesList: {
    type: 'get',
    url: `/ec-pc-api/arrival/getNodesList`
  },
  getNodesStatusList: {
    type: 'get',
    url: `/ec-pc-api/arrival/getNodesStatusList`
  },
  getSeriesList: {
    type: 'get',
    url: `/ec-pc-api/arrival/getSeriesList`
  },
  saveTheSequence: {
    type: 'post',
    url: `/ec-pc-api/customize/operate`
  },
  exportReport: {
    type: 'get',
    url: `/ec-pc-api/arrival/exportReport`,
    responseType: 'blob'
  },
  upData: {
    type: 'post',
    url: `/ec-new-product-file-api/file/import`
  },
  getData1: {
    type: 'get',
    url: `/ec-new-product-file-api/file/importHistory`
  },
  addPhotoBatchCode: {
    type: 'post',
    url: `/ec-pc-api-new/arrival/photoBatchCode/add`
  },
  getRoles: {
    type: 'get',
    url: `user-center-api/auth/getRoles`
  },
  getUserInfoByName: {
    type: 'post',
    url: '/ec-pc-api/custom/reports/data/getUserInfoByName'
  },

  // 新品上架（新）

  // 生产SPU编码
  listPage: {
    type: 'post',
    url: `/ec-goods-new-api/newProductArrival/listPage`
  },
  listPageV2: {
    type: 'post',
    url: `/ec-goods-new-api/newProductArrival/listPage_v2`
  },
  // 获取进度节点配置
  getTask: {
    type: 'get',
    url: `/ec-goods-new-api/newProductArrival/getTask`
  },
  // 生产SPU编码
  createCode: {
    type: 'get',
    url: `/ec-goods-new-api/newProductArrival/createCode`
  },
  // 新增、编辑SPU
  addSpu: {
    type: 'post',
    url: `/ec-file-api/newProductArrival/addSpu`
  },
  // 导出SPU
  exportSpu: {
    type: 'post',
    url: `/ec-goods-new-api/newProductArrival/exportSpu`
  },
  // 查询SKU
  querySku: {
    type: 'post',
    url: `/ec-goods-new-api/newProductArrival/querySku`
  },
  // SPU类别查询
  getNewProductType: {
    type: 'get',
    url: `/ec-goods-new-api/newProductArrival/getNewProductType`
  },
  getSkuRelatedProduts: {
    type: 'post',
    url: '/ec-goods-new-api/newProductArrival/getProductBySkuCode'
  },
  submitNewArriaval: {
    type: 'post',
    url: '/ec-goods-new-api/newProductArrival/newArrival'
  },
  deleteSku: {
    type: 'get',
    url: '/ec-goods-new-api/newProductArrival/delSku'
  },
  editSku: {
    type: 'post',
    url: '/ec-goods-new-api/newProductArrival/saveSku'
  },
  updateSku: {
    type: 'post',
    url: '/ec-goods-new-api/newProductArrival/updateSku'
  },
  deleteSpu: {
    type: 'get',
    url: '/ec-goods-new-api/newProductArrival/delSpu'
  },
  // 到货计划
  submitArrivalPlan: {
    type: 'post',
    url: '/ec-goods-new-api/newProductArrival/arrivalPlan'
  },
  // 确认到货
  confirmArrival: {
    type: 'post',
    url: '/ec-goods-new-api/newProductArrival/confirmArrival'
  },
  // 配货人员
  getDistributionPersons: {
    type: 'post',
    url: '/ec-goods-new-api/newProductArrival/getDistributionPerson'
  },
  // 详情查询流程信息
  getProgressInfo: {
    type: 'post',
    url: '/ec-goods-new-api/newProductArrival/getTaskNum'
  },
  // 终止、重启
  switchProcessState: {
    type: 'post',
    url: '/ec-goods-new-api/newProductArrival/skuTaskStatus'
  },
  // 刷新sku产品关联关系
  refreshAssociation: {
    type: 'get',
    url: '/ec-goods-new-api/newProductArrival/refreshRelation'
  },
  getProgressDetail: {
    type: 'get',
    url: '/ec-goods-new-api/newProductArrival/getSkuTaskDetails'
  },
  savePlan: {
    type: 'post',
    url: '/ec-goods-new-api/newProductArrival/photographyProject'
  },
  startWork: {
    type: 'post',
    url: '/ec-goods-new-api/newProductArrival/startWork'
  },
  completeWork: {
    type: 'post',
    url: '/ec-goods-new-api/newProductArrival/completeWork'
  },
  startRetouching: {
    type: 'post',
    url: '/ec-goods-new-api/newProductArrival/startThePatch'
  },
  completeRetouching: {
    type: 'post',
    url: '/ec-goods-new-api/newProductArrival/completeThePatch'
  },
  // 立即上架
  publishNow: {
    type: 'post',
    url: '/ec-goods-new-api/newProductArrival/immediatelyShelves'
  },
  getPlanPersons: {
    type: 'get',
    url: '/ec-goods-new-api/newProductArrival/planPersons'
  },
  checkFilesNew: {
    type: 'get',
    url: '/ec-goods-new-api/newProductArrival/getIsReceive'
  },
  getRelatedProductInfo: {
    type: 'post',
    url: '/ec-pc-api/product/getProductPlanInfo'
  },
  skipNode: {
    type: 'get',
    url: '/ec-goods-new-api/newProductArrival/skip/node'
  },
  listTargetPlatformGroup: {
    type: 'get',
    url: '/ec-pc-api/platform/image-tasks/listTargetPlatformGroup'
  },
  listTargetStore: {
    type: 'get',
    url: '/ec-pc-api/platform/image-tasks/listTargetStore'
  },
  imageTaskListAllStores: {
    type: 'get',
    url: '/ec-pc-api/platform/image-tasks/listAllStores'
  },
  listImageTaskSpu: {
    type: 'get',
    url: '/ec-pc-api/platform/image-tasks/listSpu'
  },
  listImageTaskSku: {
    type: 'get',
    url: '/ec-pc-api/platform/image-tasks/listSku'
  },
  listImageTaskSrcPic: {
    type: 'get',
    url: '/ec-pc-api/platform/image-tasks/listSrcPic'
  },
  imageProcessingPrecheck: {
    type: 'post',
    url: '/ec-pc-api/platform/image-processing/precheck'
  },
  imageProcessingTasks: {
    type: 'post',
    url: '/ec-pc-api/platform/image-processing/tasks'
  },
  imageTaskListParentTask: {
    type: 'post',
    url: '/ec-pc-api/platform/image-tasks/listParentTask'
  },
  imageTaskListSubTask: {
    type: 'post',
    url: '/ec-pc-api/platform/image-tasks/listSubTask'
  },
  imageTaskListBlockTargets: {
    type: 'get',
    url: '/ec-pc-api/platform/image-tasks/listBlockTargets'
  },
  imageTaskSubTaskStatistics: {
    type: 'get',
    url: '/ec-pc-api/platform/image-tasks/getSubTaskStatistics'
  },
  imageTaskStatusOption: {
    type: 'get',
    url: '/ec-pc-api/platform/image-tasks/taskStatusOption'
  },
  imageTaskImageTypeOption: {
    type: 'get',
    url: '/ec-pc-api/platform/image-tasks/imageTypeOption'
  },
  imageTaskGetTaskDetail: {
    type: 'get',
    url: '/ec-pc-api/platform/image-tasks/getTaskDetail'
  },
  imageTaskRetrySubTask: {
    type: 'post',
    url: '/ec-pc-api/platform/image-tasks/subtasks'
  },
  imageTaskRollbackSubTask: {
    type: 'post',
    url: '/ec-pc-api/platform/image-tasks/subtasks'
  }
};

const lsyApi = {
  //产品生命周期基础配置 - 下拉
  options: {
    type: 'get',
    url: '/ec-pc-api/product/cycle/assessmentRule/options'
  },
  //产品生命周期基础配置 - 删除
  delAssessmentRule: {
    type: 'get',
    url: '/ec-pc-api/product/cycle/del/assessmentRule'
  },
  //产品生命周期基础配置 - 新增
  addAssessmentRule: {
    type: 'post',
    url: '/ec-pc-api/product/cycle/add/assessmentRule'
  },
  //产品生命周期基础配置 - 编辑
  updateAssessmentRule: {
    type: 'post',
    url: '/ec-pc-api/product/cycle/update/assessmentRule'
  },
  //产品生命周期管理 - 大型号品类分布列表
  categoryList: {
    type: 'post',
    url: '/ec-pc-api/product/cycle/bigModel/categoryList'
  },
  //产品生命周期管理 - 大型号品类分布列表导出
  categoryListExport: {
    type: 'post',
    url: '/ec-pc-api/product/cycle/bigModel/categoryListExport'
  },
  //产品生命周期管理 - 大型号产品类别概览列表
  proTypeList: {
    type: 'post',
    url: '/ec-pc-api/product/cycle/bigModel/proTypeList'
  },
  //产品生命周期管理 - 大型号产品类别概览列表导出
  proTypeListExport: {
    type: 'post',
    url: '/ec-pc-api/product/cycle/bigModel/proTypeListExport'
  },
  //产品生命周期管理 - 产品滞销情况列表
  productUnsoldList: {
    type: 'post',
    url: '/ec-pc-api/product/cycle/unsold/productUnsoldList'
  },
  //产品生命周期管理 - 产品滞销情况导出
  productUnsoldListExport: {
    type: 'post',
    url: '/ec-pc-api/product/cycle/unsold/productUnsoldListExport'
  },
  //产品生命周期管理 - 产品滞销情况 - 品类下拉
  getCategory: {
    type: 'get',
    url: '/ec-pc-api/product/cycle/getCategory'
  },
  //产品生命周期管理 - 大型号销售定位概览
  bigModelSalesOverview: {
    type: 'post',
    url: '/ec-pc-api/product/cycle/bigModelSalesOverview'
  },
  //产品生命周期管理 - 大型号销售定位概览 - 导出
  bigModelSalesOverviewExport: {
    type: 'post',
    url: '/ec-pc-api/product/cycle/bigModelSalesOverviewExport'
  },
  //销售定位下拉
  queryMarketingPositioning: {
    type: 'get',
    url: '/ec-pc-api/product/queryMarketingPositioning'
  },
  //大型号tab页动态下拉
  dynamicOptions: {
    type: 'post',
    url: '/ec-pc-api/product/cycle/bigModel/dynamic/options'
  },
  //产品tab页动态下拉
  proOptions: {
    type: 'get',
    url: '/ec-pc-api/product/cycle/pro/dynamic/options'
  },
  //品类销售定位计算规则
  saleLocationCalcRule: {
    type: 'get',
    url: '/ec-pc-api/product/cycle/saleLocation/calcRule'
  },
  assessmentRulesList: {
    type: 'post',
    url: '/ec-pc-api/product/cycle/assessmentRulesList'
  },
  queryProductDataCopywriting: {
    type: 'post',
    url: '/ec-goods-new-api/newProductArrival/queryProductDataCopywriting'
  },
  newProductArrivalUpload: {
    type: 'upload',
    url: '/ec-goods-new-api/newProductArrival/upload'
  },
  startShootingPlanList: {
    type: 'post',
    url: '/ec-goods-new-api/newProductArrival/startShootingPlanList'
  },
  planAdjustment: {
    type: 'post',
    url: '/ec-goods-new-api/newProductArrival/planAdjustment'
  },
  // 总览
  // 新品制作总览
  newProductProductionOverview: {
    type: 'post',
    url: '/ec-goods-new-api/newProductArrival/newProductProductionOverview'
  },
  // 进度总览：根据品类查询产品各节点数量
  skuTaskSum: {
    type: 'post',
    url: '/ec-goods-new-api/newProductArrival/skuTaskSum'
  },
  // 新品制作总览数据总计
  newProductProductionTotalData: {
    type: 'get',
    url: '/ec-goods-new-api/newProductArrival/newProductProductionTotalData'
  },
  // 查询节点平均耗时
  getSkuTaskAvgTime: {
    type: 'post',
    url: '/ec-goods-new-api/newProductArrival/getSkuTaskAvgTime'
  },
  // 查询节点平均耗时
  cateGoryList: {
    type: 'get',
    url: '/ec-goods-new-api/newProductArrival/cateGoryList'
  },
  // 已上架SPU数量查询
  getSpuMonthNum: {
    type: 'get',
    url: '/ec-goods-new-api/newProductArrival/getSpuMonthNum'
  },

  // 已评审产品
  // 列表
  reviewProducts: {
    type: 'post',
    url: '/ec-goods-new-api/newProductArrival/reviewProducts'
  },
  // 编辑新增
  reviewProductSaveOrUpdate: {
    type: 'post',
    url: '/ec-goods-new-api/newProductArrival/reviewProductSaveOrUpdate'
  },
  // 取评审产品配置项
  getSoftProductConfig: {
    type: 'post',
    url: '/ec-pc-api/softProduct/getSoftProductConfig'
  },
  // 评审产品删除
  delProduct: {
    type: 'post',
    url: '/ec-goods-new-api/newProductArrival/delProduct'
  },
  // 生成评审批次号
  generateReviewBatchNo: {
    type: 'post',
    url: '/ec-goods-new-api/newProductArrival/generateReviewBatchNo'
  },
  // 查询评审批次号
  getReviewBatchNo: {
    type: 'post',
    url: '/ec-goods-new-api/newProductArrival/getReviewBatchNo'
  },
  // 查询当前节点所有操作人
  getDevicePerson: {
    type: 'get',
    url: '/ec-goods-new-api/newProductArrival/getDevicePerson'
  },
  // 根据查询SPU各节点数量
  spuTaskNum: {
    type: 'post',
    url: '/ec-goods-new-api/newProductArrival/spuTaskNum'
  },
  // 根据查询SPU各节点数量
  queryNewProductPageDateFlag: {
    type: 'get',
    url: '/ec-goods-new-api/newProductArrival/queryNewProductPageDateFlag'
  },
  // SPU 产品资料 分页
  spuFileListPage: {
    type: 'post',
    url: '/ec-goods-new-api/newProductArrival/spuFileListPage'
  },
  // 调整更新说明
  updateInstructions: {
    type: 'post',
    url: '/ec-goods-new-api/newProductArrival/updateInstructions'
  },
  // SPU跳过文案上传节点
  skipTask: {
    type: 'get',
    url: '/ec-goods-new-api/newProductArrival/skipTask'
  },
  // SPU跳过 设计节点
  skipDesignTask: {
    type: 'get',
    url: '/ec-goods-new-api/newProductArrival/skipDesignTask'
  },
  // SPU跳过 产品资料上传节点
  proMaterialTask: {
    type: 'get',
    url: '/ec-goods-new-api/newProductArrival/skip/proMaterialTask'
  },
  // 修改备注
  addProductRemark: {
    type: 'post',
    url: '/ec-goods-new-api/newProductArrival/addProductRemark'
  },
  // 查询备注
  queryProductRemark: {
    type: 'post',
    url: '/ec-goods-new-api/newProductArrival/queryProductRemark'
  },
  // 订单制（SKU忽略首批需求）
  skipDemand: {
    type: 'post',
    url: '/ec-goods-new-api/newProductArrival/skipDemand'
  },
  // 查询说辞表tab页spu分页
  queryExcuseSpuList: {
    type: 'post',
    url: '/ec-goods-new-api/newProductArrival/queryExcuseSpuList'
  },
  // 产品资料-说辞表导入
  informationImport: {
    type: 'post',
    url: '/ec-goods-new-api/newProductArrival/information/import'
  },
  // 查询产品资料-说辞表预览数据
  queryExcuseData: {
    type: 'post',
    url: '/ec-goods-new-api/newProductArrival/queryExcuseData'
  },
  // 产品资料上传
  informationUpload: {
    type: 'upload',
    url: '/ec-file-api/newProductArrival/information/upload'
    // url: '/ec-goods-new-api/newProductArrival/information/upload'
  },
  // 产品资料信息编辑
  editInformation: {
    type: 'post',
    url: '/ec-goods-new-api/newProductArrival/editInformation'
  },
  // 说辞表信息替换
  replaceExcuseData: {
    type: 'post',
    url: '/ec-goods-new-api/newProductArrival/replaceExcuseData'
  },
  // 产品资料修改记录
  getChangeRecord: {
    type: 'get',
    url: '/ec-goods-new-api/newProductArrival/getChangeRecord'
  },
  // 产品资料信息全部替换前的spu信息列表
  getInformationSpuList: {
    type: 'get',
    url: '/ec-goods-new-api/newProductArrival/getInformationSpuList'
  },
  // 替换选择的spu说词表信息
  editInformationAll: {
    type: 'post',
    url: '/ec-goods-new-api/newProductArrival/editInformationAll'
  },
  // 信息表/bom-分页
  bominfoPage: {
    type: 'post',
    url: '/ec-goods-new-api/newProductArrival/bominfoPage'
  },
  // 移除SPU和资料上传关系(boom、信息表)
  delSpuBom: {
    type: 'post',
    url: '/ec-goods-new-api/newProductArrival/delSpuBom'
  },
  // 信息表/bom表资料上传-待选列表
  getSpuBomPage: {
    type: 'post',
    url: '/ec-goods-new-api/newProductArrival/getSpuBomPage'
  },
  // 编辑SPU和资料上传关系(boom、信息表)
  updateSpuBom: {
    type: 'post',
    url: '/ec-goods-new-api/newProductArrival/updateSpuBom'
  },
  // 查询产品资料上传记录
  queryUploadHistory: {
    type: 'post',
    url: '/ec-goods-new-api/newProductArrival/queryUploadHistory'
  },
  // 说辞表文件下载
  downLoadExcuseExcel: {
    type: 'post',
    url: '/ec-goods-new-api/newProductArrival/downLoadExcuseExcel'
  },
  //SPU信息筛选
  filterRate:{
    type:'get',
    url:'/ec-goods-new-api/newProductArrival/spu/filtrate'
  },
  //产品资料-信息表-bom表预览
  informationPreview:{
    type:'get',
    url:'/ec-goods-new-api/newProductArrival/information/preview'
  },
  //渲染-开始渲染
  startRendering:{
    type:'post',
    url:'/ec-goods-new-api/newProductArrival/startRendering'
  },
  //渲染-完成渲染
  completeRendering:{
    type:'post',
    url:'/ec-goods-new-api/newProductArrival/completeRendering'
  },
  //滞销等级配置-列表
  configLevelInfoList:{
    type: 'get',
    url: '/ec-pc-api/unsalable/product/config/levelInfoList'
  },
  //影响因子配置-列表
  configImpactFactors:{
    type: 'get',
    url: '/ec-pc-api/unsalable/product/config/impactFactors'
  },
  //滞销等级配置-更新
  levelInfoListUpdate:{
    type: 'post',
    url: '/ec-pc-api/unsalable/product/config/levelInfoList/update'
  },
  //历史修改记录分页
  modifyInfoSearch:{
    type: 'post',
    url: '/ec-pc-api/unsalable/product/history/modifyInfo/search'
  },
  //影响因子配置-更新
  impactFactorsUpdate:{
    type: 'post',
    url: '/ec-pc-api/unsalable/product/config/impactFactors/udpate'
  },
  //预退配置店铺权限-新增-编辑
  saveOrUpdate:{
    type: 'post',
    url: '/ec-pc-api/cycle/delist/storeUser/saveOrUpdate'
  },
  //店铺权限-删除
  storeUserDel:{
    type: 'get',
    url: '/ec-pc-api/cycle/delist/storeUser/del'
  },
  //节点时间配置-编辑
  processTimeConfigUpdate:{
    type: 'post',
    url: '/ec-pc-api/cycle/delist/processTimeConfig/update'
  },
  //节点时间配置-删除
  processTimeConfigDel:{
    type: 'get',
    url: '/ec-pc-api/cycle/delist/processTimeConfig/del'
  },
  //摄影师配置-新增
  cameramanConfigSave:{
    type: 'post',
    url: '/ec-goods-new-api/newProductArrival/cameramanConfig/save'
  },
  //摄影师配置-编辑
  cameramanConfigUpdate:{
    type: 'post',
    url: '/ec-goods-new-api/newProductArrival/cameramanConfig/update'
  },
  //摄影师配置-删除
  cameramanConfigDel:{
    type: 'get',
    url: '/ec-goods-new-api/newProductArrival/cameramanConfig/del'
  },
  //拍摄核算标准-新增-更新
  shootingAccountingConfigSave:{
    type: 'post',
    url: '/ec-goods-new-api/newProductArrival/shootingAccountingConfig/save'
  },
  //拍摄核算标准-删除
  shootingAccountingConfigDel:{
    type: 'get',
    url: '/ec-goods-new-api/newProductArrival/shootingAccountingConfig/del'
  },  
  //拍摄核算标准-启用-停用
  shootingAccountingConfigUpdateStatus:{
    type: 'get',
    url: '/ec-goods-new-api/newProductArrival/shootingAccountingConfig/updateStatus'
  },  
  //拍摄类型-动态分页
  shootingTypeSearch:{
    type: 'post',
    url: '/ec-goods-new-api/newProductArrival/shootingType/search'
  },  
  //拍摄类型-更新配置
  shootingTypeUpdate:{
    type: 'post',
    url: '/ec-goods-new-api/newProductArrival/shootingType/update'
  },  
  //摄影工资核算汇总信息
  shootingAccountSumInfoSearch:{
    type: 'post',
    url: '/ec-goods-new-api/newProductArrival/shootingAccount/sumInfo/search'
  },  
  //摄影工资核算汇总信息-导出
  shootingAccountSumInfoExport:{
    type: 'post',
    url: '/ec-goods-new-api/newProductArrival/shootingAccount/sumInfo/export'
  },  
  //摄影工资核算汇总信息-更新作品得分
  shootingAccountSumInfoUpdateScore:{
    type: 'post',
    url: '/ec-goods-new-api/newProductArrival/shootingAccount/sumInfo/updateScore'
  },  
  //提成系数配置-更新
  commissionConfigUpdate:{
    type: 'post',
    url: '/ec-goods-new-api/newProductArrival/commissionConfig/update'
  },  
  //渲染类型-更新配置
  renderTypeUpdate:{
    type: 'post',
    url: '/ec-goods-new-api/newProductArrival/renderType/update'
  },  
  //渲染类型-更新配置
  batchUploadProductPicture:{
    type: 'post',
    url: '/ec-file-api/newProductArrival/batchUpload/product/picture'
    // url: '/ec-goods-new-api/newProductArrival/batchUpload/product/picture'
  },  
  //产品图片-树形列表
  pictureTreeMenus:{
    type: 'get',
    url: '/ec-goods-new-api/newProductArrival/picture/treeMenus'
  },    
  //产品图片-树形列表-流程类型下拉列表
  processTypeList:{
    type: 'get',
    url: '/ec-goods-new-api/newProductArrival/picture/treeMenus/processTypeList'
  },  
  //产品图片-批量删除
  pictureDel:{
    type: 'post',
    url: '/ec-file-api/newProductArrival/picture/del'
    // url: '/ec-goods-new-api/newProductArrival/picture/del'
  },  
  //节点回退
  processRollback:{
    type: 'post',
    url: '/ec-goods-new-api/newProductArrival/process/rollback'
  },  
  //产品图片-下载
  pictureDownload:{
    type: 'post',
    url: '/ec-file-api/newProductArrival/picture/download'
  },  
  //产品图片-下载(批量)
  pictureDownloadBatch:{
    type: 'post',
    url: '/ec-file-api/newProductArrival/picture/download/batch'
  },  
  //产品图片汇总-图片详情
  pictureDetail:{
    type: 'post',
    url: '/ec-goods-new-api/newProductArrival/picture/detail'
  },  
  //模特图选项下拉列表
  pictureModel:{
    type: 'get',
    url: '/ec-goods-new-api/newProductArrival/product/picture/model'
  },  
  //批量上传切片图片
  pictureSection:{
    type: 'post',
    url: '/ec-file-api/newProductArrival/batchUpload/product/picture/section'
    // url: '/ec-goods-new-api/newProductArrival/batchUpload/product/picture/section'
  },  
  //按SPU获取产品图片目录树
  pictureTreeMenu:{
    type: 'get',
    url: '/ec-goods-new-api/newProductArrival/picture/treeMenu'
  },  
  //获取统计信息
  getStatisticsInfo:{
    type: 'get',
    url: '/ec-goods-new-api/newProductArrival/getStatisticsInfo'
  },  
  //根据SKU查询产品信息
  getProductBySkuCodeList:{
    type: 'post',
    url: '/ec-goods-new-api/newProductArrival/getProductBySkuCodeList'
  },  
  //切片上传弹窗信息获取
  uploadPopup:{
    type: 'get',
    url: '/ec-goods-new-api/slice/up/uploadPopup'
  },  
  //切片上传
  sliceUpload:{
    type: 'post',
    url: '/ec-file-api/slice/up/upload'
  },  
  //查询切片文件目录树
  querySliceUpFolderTree: {
    type: 'post',
    url: '/ec-file-api/slice/up/querySliceUpFolderTree'
  },
  // 切片文件层级转换-扫描
  sliceConvertScan: {
    type: 'post',
    url: '/ec-file-api/slice/convert/scan'
  },
  // 切片文件层级转换-任务明细
  sliceConvertDetail: {
    type: 'post',
    url: '/ec-file-api/slice/convert/detail'
  },
  // 切片文件层级转换-修改目标位置
  sliceConvertUpdateTarget: {
    type: 'post',
    url: '/ec-file-api/slice/convert/item/updateTarget'
  },
  // 切片文件层级转换-重命名文件夹
  sliceConvertRenameFolder: {
    type: 'post',
    url: '/ec-file-api/slice/convert/item/renameFolder'
  },
  // 切片文件层级转换-预览新目录
  sliceConvertPreview: {
    type: 'post',
    url: '/ec-file-api/slice/convert/preview'
  },
  // 切片文件层级转换-下载
  sliceConvertDownload: {
    type: 'post',
    url: '/ec-file-api/slice/convert/download'
  },
  // 切片文件层级转换-确认上传
  sliceConvertConfirm: {
    type: 'post',
    url: '/ec-file-api/slice/convert/confirm'
  },
  // 切片文件层级转换-取消任务
  sliceConvertCancel: {
    type: 'post',
    url: '/ec-file-api/slice/convert/cancel'
  },
  //切片上传-查询当前层级下的文件夹目录与文件
  getUploadDetail:{
    type: 'get',
    url: '/ec-goods-new-api/slice/up/getUploadDetail'
  },  
  //切片地址管理-分页
  sliceAddressListPage:{
    type: 'post',
    url: '/ec-goods-new-api/slice/up/sliceAddressListPage'
  },  
  //产品拍摄图片管理-切片初始化，搜索树结构
  getSliceTree:{
    type: 'post',
    url: '/ec-goods-new-api/slice/up/getSliceTree'
  },  
  //产品拍摄图片管理-查询当前层级下的文件夹目录与文件
  getCurrentLevelFolderAndFile:{
    type: 'post',
    url: '/ec-goods-new-api/slice/up/getCurrentLevelFolderAndFile'
  },  
  //产品拍摄图片管理-批量上传记录
  batchUploadRecord:{
    type: 'post',
    url: '/ec-goods-new-api/slice/up/batchUploadRecord'
  },  
  //产品拍摄图片管理-旧-批量上传
  oldBatchUpload:{
    type: 'post',
    url: '/ec-file-api/slice/up/oldBatchUpload'
  },  
  //产品拍摄图片管理-删除
  sliceDelete:{
    type: 'post',
    url: '/ec-file-api/slice/up/delete'
  },  
  //产品拍摄图片管理-下载
  sliceDownload:{
    type: 'post',
    url: '/ec-file-api/slice/up/download'
  },  
  //查询需上传修片产品
  retouchQueryRetouchUploadProduct:{
    type: 'get',
    url: '/ec-goods-new-api/retouch/queryRetouchUploadProduct'
  },  
  //回退记录查询
  productBackRecordPage:{
    type: 'post',
    url: '/ec-goods-new-api/retouch/productBackRecordPage'
  },  
  //回退查询产品信息
  queryRetouchRollBackProduct:{
    type: 'post',
    url: '/ec-goods-new-api/retouch/queryRetouchRollBackProduct'
  },  
  //查询sku修片是否完成
  retouchQuerySkuFinish:{
    type: 'post',
    url: '/ec-goods-new-api/retouch/querySkuFinish'
  },  
  //查询需上传渲染产品
  queryRenderingUploadProduct:{
    type: 'get',
    url: '/ec-goods-new-api/retouch/queryRenderingUploadProduct'
  },  
  //工作量核算标准查询
  queryWorkloadCalculates:{
    type: 'get',
    url: '/ec-goods-new-api/shootConfig/queryWorkloadCalculates'
  },  
  //工作量核算标准编辑
  updateWorkloadCalculate:{
    type: 'post',
    url: '/ec-goods-new-api/shootConfig/updateWorkloadCalculate'
  },  
  //提成核算查询
  queryCommissionCalculates:{
    type: 'get',
    url: '/ec-goods-new-api/shootConfig/queryCommissionCalculates'
  },  
  //提成核算配置保存
  saveOrUpdateCommissionCalculate:{
    type: 'post',
    url: '/ec-goods-new-api/shootConfig/saveOrUpdateCommissionCalculate'
  },  
  //提成系数查询
  queryCommissionFactors:{
    type: 'get',
    url: '/ec-goods-new-api/shootConfig/queryCommissionFactors'
  },  
  //提成系数配置保存
  saveOrUpdateCommissionFactor:{
    type: 'post',
    url: '/ec-goods-new-api/shootConfig/saveOrUpdateCommissionFactor'
  },  
  //提成核算-系数调整记录查询
  commissionCalculateModifyRecordPage:{
    type: 'post',
    url: '/ec-goods-new-api/shootConfig/commissionCalculateModifyRecordPage'
  },  
  //修片师工资核算汇总查询
  photographerPayrollPage:{
    type: 'post',
    url: '/ec-goods-new-api/photographerPayroll/photographerPayrollPage'
  },  
  //得分编辑
  photographerPayrollUpdateScore:{
    type: 'post',
    url: '/ec-goods-new-api/photographerPayroll/updateScore'
  },  
  //产品拍摄图片管理-修片旧-批量上传
  oldRetouchBatchUpload:{
    type: 'post',
    url: '/ec-file-api/slice/up/oldRetouchBatchUpload'
  },  
}
//样品与首套图上传
const samplePicturesImport = {
  //通过'产品名称'、'产品型号'查询前50条数据
  filterProductData: {
    type: 'post',
    url: '/ec-pc-api/productCheckImg/filterProductData'
  },
  //不一致处理
  productCheckImgHandleDiff: {
    type: 'post',
    url: '/ec-pc-api/productCheckImg/handleDiff'
  },
  //提醒视觉上传
  productCheckImgNotice: {
    type: 'post',
    url: '/ec-pc-api/productCheckImg/notice'
  },
  //上传图片-查询产品信息
  productImgPreCheck: {
    type: 'post',
    url: '/ec-pc-api/productCheckImg/productImgPreCheck'
  },
  //回退
  productCheckImgRollback: {
    type: 'post',
    url: '/ec-pc-api/productCheckImg/rollback'
  },
  //回退记录
  productCheckImgRollbackRecord: {
    type: 'post',
    url: '/ec-pc-api/productCheckImg/rollbackRecord'
  },
  //提交上传图片信息
  productCheckImgSubmitImgInfo: {
    type: 'post',
    url: '/ec-pc-api/productCheckImg/submitImgInfo'
  },
  //列表-查询[拍样|首套]图片详情
  productCheckImgViewUploadImg: {
    type: 'get',
    url: '/ec-pc-api/productCheckImg/viewUploadImg'
  },
  //补充上传图片信息
  supplementImgInfo: {
    type: 'post',
    url: '/ec-pc-api/productCheckImg/supplementImgInfo'
  },
  //临时产品分页查询
  tempProductPage: {
    type: 'post',
    url: '/ec-pc-api/productCheckImg/tempProductPage'
  },
}

//产品模型管理
const productModel = {
  //批量上传
  productModelBatchUpload: {
    type: 'post',
    url: '/ec-file-api/productModel/batchUpload'
  },
  //批量上传记录
  productModelBatchUploadRecord: {
    type: 'post',
    url: '/ec-goods-new-api/productModel/batchUploadRecord'
  },
  //删除
  productModelDelete: {
    type: 'post',
    url: '/ec-file-api/productModel/delete'
  },
  //下载
  productModelDownload: {
    type: 'post',
    url: '/ec-file-api/productModel/download'
  },
  //查询当前层级下的文件夹目录与文件
  productModelGetCurrentLevelFolderAndFile: {
    type: 'post',
    url: '/ec-goods-new-api/productModel/getCurrentLevelFolderAndFile'
  },
  //产品模型树结构查询
  productModelGetSliceTree: {
    type: 'post',
    url: '/ec-goods-new-api/productModel/getSliceTree'
  },
  //渲染节点 模型图批量上传
  productModelrRenderBatchUpload: {
    type: 'post',
    url: '/ec-file-api/productModel/renderBatchUpload'
  },
  //产品模型汇总分页查询
  productModelPageQuery: {
    type: 'post',
    url: '/ec-goods-new-api/productModel/productModelPageQuery'
  },
  //清单列表查询
  productListPage: {
    type: 'post',
    url: '/ec-goods-new-api/productList/page'
  },
  //删除清单
  productListDel: {
    type: 'post',
    url: '/ec-goods-new-api/productList/deleteNewProductList'
  },
  //获取负责人
  productListGetUser: {
    type: 'get',
    url: '/ec-goods-new-api/productList/getUser'
  },
  //清单-新增编辑
  productListSave: {
    type: 'post',
    url: '/ec-goods-new-api/productList/save'
  },
  //清单-清单详情
  getNewProductListInfo: {
    type: 'post',
    url: '/ec-goods-new-api/productList/getNewProductListInfo'
  },
  //获取清单spu详情
  productListGetDetail: {
    type: 'post',
    url: '/ec-goods-new-api/productList/getDetail'
  },
  //SPU查询
  spuPage: {
    type: 'post',
    url: '/ec-goods-new-api/productList/spuPage'
  },
  //添加商品
  appendSpuSku: {
    type: 'post',
    url: '/ec-goods-new-api/productList/appendSpuSku'
  },
  //发布
  productListPublish: {
    type: 'post',
    url: '/ec-goods-new-api/productList/publish'
  },
  //新品上市清单详情列表
  productListDetailList: {
    type: 'post',
    url: '/ec-goods-new-api/productList/detailList'
  },
  //新品上市清单详情列表导出
  detailListExport: {
    type: 'post',
    url: '/ec-goods-new-api/productList/detailListExport'
  },
  //新品上市清单详情-基础信息未维护导入模版下载
  downBaseTemplate: {
    type: 'post',
    url: '/ec-goods-new-api/productList/downBaseTemplate'
  },
  //新品上市清单详情-基础信息未维护导入
  importBaseData: {
    type: 'post',
    url: '/ec-goods-new-api/productList/importBaseData'
  },
  //新品上市清单详情-产品文案未维护导入
  importProductData: {
    type: 'post',
    url: '/ec-goods-new-api/productList/importProductData'
  },
  //新品上市清单详情-产品文案未维护导入模版下载
  downProductTemplate: {
    type: 'post',
    url: '/ec-goods-new-api/productList/downProductTemplate'
  },
  //移至其他清单-未发布清单查询
  queryNoPublishNewProductList: {
    type: 'post',
    url: '/ec-goods-new-api/productList/queryNoPublishNewProductList'
  },
  //移至其他清单-迁移接口
  moveNewProductList: {
    type: 'post',
    url: '/ec-goods-new-api/productList/moveNewProductList'
  },
  //新品上市清单详情统计接口
  productListStatics: {
    type: 'post',
    url: '/ec-goods-new-api/productList/statics'
  },
  //详情列表删除商品
  productListDeleteItem: {
    type: 'post',
    url: '/ec-goods-new-api/productList/deleteItem'
  },
  //基础信息未维护编辑
  productListBaseEdit: {
    type: 'post',
    url: '/ec-goods-new-api/productList/baseEdit'
  },
  //产品文案编辑
  productListProductEdit: {
    type: 'post',
    url: '/ec-goods-new-api/productList/productEdit'
  },
  //产品价格清单查询
  productListPriceList: {
    type: 'post',
    url: '/ec-goods-new-api/productList/priceList'
  },
  //产品价格清单查询-导出
  priceListExport: {
    type: 'post',
    url: '/ec-goods-new-api/productList/priceListExport'
  },
  //商品编辑记录查询
  productListLogs: {
    type: 'post',
    url: '/ec-goods-new-api/productList/logs'
  },
  //新品上架-状态tab统计接口
  statisticsByState: {
    type: 'get',
    url: '/ec-goods-new-api/productListUp/statisticsByState'
  },
  //新品上架-列表
  productListUpPage: {
    type: 'post',
    url: '/ec-goods-new-api/productListUp/page'
  },
  //新品上架-店铺tab统计接口
  statisticsByStore: {
    type: 'post',
    url: '/ec-goods-new-api/productListUp/statisticsByStore'
  },
  //新品上架-上架
  productListUpNew: {
    type: 'post',
    url: '/ec-goods-new-api/productListUp/up'
  },
  //新品上架-无需上架
  productListUpNoNeedUp: {
    type: 'post',
    url: '/ec-goods-new-api/productListUp/noNeedUp'
  },
  //新品上架-暂缓上架
  productListUpCannotUp: {
    type: 'post',
    url: '/ec-goods-new-api/productListUp/cannotUp'
  },
  //新品上架-下架
  productListUpDown: {
    type: 'post',
    url: '/ec-goods-new-api/productListUp/down'
  },
  //新品上架统计-上市清单列表
  listStatisPage: {
    type: 'post',
    url: '/ec-goods-new-api/productListUp/listStatisPage'
  },
  //新品上架统计-商品列表
  listGoodsStatiscs: {
    type: 'post',
    url: '/ec-goods-new-api/productListUp/listGoodsStatiscs'
  },
  //新品上架统计-商品上架店铺详情
  listGoodsDetail: {
    type: 'post',
    url: '/ec-goods-new-api/productListUp/listGoodsDetail'
  },
  //新品上架统计-获取商品上架店铺
  querySkuStore: {
    type: 'post',
    url: '/ec-goods-new-api/productListUp/querySkuStore'
  },
  //新品上架统计-店铺上架商品详情
  listStoreDetail: {
    type: 'post',
    url: '/ec-goods-new-api/productListUp/listStoreDetail'
  },
  //新品上架统计-店铺列表
  listStore: {
    type: 'post',
    url: '/ec-goods-new-api/productListUp/listStore'
  },
  //准备上架失败列表
  prepareErrorPageList: {
    type: 'post',
    url: '/ec-goods-new-api/productListUp/prepareErrorPageList'
  },
  //新品上架列表导出
	productListUpExport: {
		url: '/ec-goods-new-api/productListUp/page/export',
		type: 'post'
	},
  //获取spu上架店铺
  getSpuStore: {
    type: 'get',
    url: '/ec-goods-new-api/newProductArrival/getSpuStore'
  },
  //调整内容待处理数量统计
  adjustContentStatics: {
    type: 'post',
    url: '/ec-goods-new-api/msgNotice/adjustContentStatics'
  },
  //店铺待处理数量统计
  storeStatics: {
    type: 'post',
    url: '/ec-goods-new-api/msgNotice/storeStatics'
  },
  //在售品信息变更列表
  msgNoticePage: {
    type: 'post',
    url: '/ec-goods-new-api/msgNotice/page'
  },
  //在售品信息变更列表 - 批量操作
  msgNoticeDeal: {
    type: 'post',
    url: '/ec-goods-new-api/msgNotice/deal'
  },
  //获取是否展示调整类型
  getShowAdjustType: {
    type: 'get',
    url: '/ec-goods-new-api/msgNotice/getShowAdjustType'
  },
  //新品上市清单合并导出
  productListExport: {
    type: 'post',
    url: '/ec-goods-new-api/productList/export'
  },
  //型号销量表
  modelSaleDetail: {
    type: 'post',
    url: '/ec-pc-api/product/cycle/detail/modelSaleDetail'
  },
  //店铺销售额详情
  storeSaleAmount: {
    type: 'post',
    url: '/ec-pc-api/merchandise/sales/store/saleAmount'
  },
  //新品上架统计明细
  productListUpDetailList: {
    type: 'post',
    url: '/ec-goods-new-api/productListUp/detailList'
  },
  //店铺汇总列表查询
  onSaleUpdateStorePage: {
    type: 'post',
    url: '/ec-goods-new-api/onSaleUpdate/storePage'
  },
  //价格相关、设计图变更、其他信息变更列表
  onSaleUpdatePageItem: {
    type: 'post',
    url: '/ec-goods-new-api/onSaleUpdate/pageItem'
  },
  //切片未通知统计列表
  sliceNoticeQuery: {
    type: 'post',
    url: '/ec-goods-new-api/msgNotice/sliceNoticeQuery'
  },
  //型号销量表导出
  modelSaleDetailExport: {
    type: 'post',
    url: '/ec-pc-api/product/cycle/detail/modelSaleDetailExport'
  },
  //更新产品编码
  updateSpuProduct: {
    type: 'post',
    url: '/ec-file-api/newProductArrival/updateSpuProduct'
  },
  //删除产品
  deleteProductCode: {
    type: 'post',
    url: '/ec-file-api/newProductArrival/deleteProductCode'
  },
  //SPU查询新
  listPageNew: {
    type: 'post',
    url: '/ec-goods-new-api/newProductArrival/listPageNew'
  },
  //切片上传进度查询
  querySliceUploadQuery: {
    type: 'get',
    url: '/ec-goods-new-api/newProductArrival/querySliceUploadQuery',
  },
  //通栏图树结构查询
  fullWidthUploadGetSliceTree: {
    type: 'post',
    url: '/ec-goods-new-api/fullWidthUpload/getSliceTree',
  },
  //调整记录查询
  fullWidthUploadAdjustPage: {
    type: 'post',
    url: '/ec-goods-new-api/fullWidthUpload/adjustPage',
  },
  //查询当前层级下的文件夹目录与文件
  fullWidthUploadGetCurrentLevelFolderAndFile: {
    type: 'post',
    url: '/ec-goods-new-api/fullWidthUpload/getCurrentLevelFolderAndFile',
  },
  //批量上传
  fullWidthBatchUpload: {
    type: 'post',
    url: '/ec-file-api/fullWidth/batchUpload',
  },
  //删除文件夹（发通知）
  fullWidthDeleteFolder: {
    type: 'post',
    url: '/ec-file-api/fullWidth/deleteFolder',
  },
  //修改（发通知）
  fullWidthBatchUploadUpdate: {
    type: 'post',
    url: '/ec-file-api/fullWidth/batchUploadUpdate',
  },
  //删除文件夹（不发通知）
  fullWidthDeleteFolderNotNotice: {
    type: 'post',
    url: '/ec-file-api/fullWidth/deleteFolderNotNotice',
  },
  //修改文件夹（不发通知）
  fullWidthUpdateFolderNotNotice: {
    type: 'post',
    url: '/ec-file-api/fullWidth/updateFolderNotNotice',
  },
  //新增文件夹（不发通知）
  fullWidthAddFolderNotNotice: {
    type: 'post',
    url: '/ec-file-api/fullWidth/addFolderNotNotice',
  },
  //下载
  fullWidthDownload: {
    type: 'post',
    url: '/ec-file-api/fullWidth/download',
  },
  //待处理、暂缓处理数量统计
  waiteAndNotStatics: {
    type: 'post',
    url: '/ec-goods-new-api/msgNotice/waiteAndNotStatics',
  },
  //获取是否展示修改作废按钮
  getShowVoidBtn: {
    type: 'post',
    url: '/ec-goods-new-api/newProductArrival/getShowBtn',
  },
  //设计图导出
  exportDesign: {
    type: 'post',
    url: '/ec-goods-new-api/msgNotice/exportDesign',
  },
  //店铺装修图管理-文件夹树
  platformImageRuleGroups: {
    type: 'get',
    url: '/ec-pc-api/platform/image-rule/groups',
  },
  platformImageRuleList: {
    type: 'get',
    url: '/ec-pc-api/platform/image-rule/list',
  },
  platformImageRuleDetail: {
    type: 'get',
    url: '/ec-pc-api/platform/image-rule/detail',
  },
  platformImageRulePublish: {
    type: 'post',
    url: '/ec-pc-api/platform/image-rule/publish',
  },
  platformImageRuleVersionDetail: {
    type: 'get',
    url: '/ec-pc-api/platform/image-rule/version/detail',
  },
  platformImageRuleVersions: {
    type: 'get',
    url: '/ec-pc-api/platform/image-rule/versions',
  },
  storeDecorationFolderTree: {
    type: 'post',
    url: '/ec-pc-api/store/decoration/getTreeEnum',
  },
  //店铺装修图管理-保存搜索记录
  storeDecorationSaveSearchLog: {
    type: 'get',
    url: '/ec-pc-api/store/decoration/saveSearchLog',
  },
  //店铺装修图管理-AI素材列表
  storeDecorationAiMaterialList: {
    type: 'post',
    url: '/ec-pc-api/store/decoration/fileInfo/list',
  },
  //店铺装修图管理-AI素材上传
  storeDecorationAiMaterialUpload: {
    type: 'post',
    url: '/ec-file-api/storeDecoration/upload',
  },
  //店铺装修图管理-AI素材评分
  storeDecorationAiMaterialScore: {
    type: 'get',
    url: '/ec-pc-api/store/decoration/aiMaterialStarNum',
  },
  //店铺装修图管理-AI素材删除
  storeDecorationAiMaterialDelete: {
    type: 'post',
    url: '/ec-file-api/storeDecoration/delete',
  },
  //店铺装修图管理-AI素材下载
  storeDecorationAiMaterialDownload: {
    type: 'post',
    url: '/ec-file-api/storeDecoration/download',
  },
  //店铺装修图管理-店铺活动图列表
  storeDecorationActivityMaterialList: {
    type: 'post',
    url: '/ec-pc-api/store/decoration/fileInfo/list',
  },
  //店铺装修图管理-店铺底图上传
  storeDecorationActivityBaseUpload: {
    type: 'post',
    url: '/ec-file-api/storeDecoration/uploadStoreDecorationImg',
  },
  //店铺装修图管理-店铺活动图删除
  storeDecorationActivityMaterialDelete: {
    type: 'post',
    url: '/ec-file-api/storeDecoration/delete',
  },
  //店铺装修图管理-店铺活动图下载
  storeDecorationActivityMaterialDownload: {
    type: 'post',
    url: '/ec-file-api/storeDecoration/download',
  },
  //店铺装修图管理-异步任务查询
  storeDecorationDownloadTaskInfo: {
    type: 'get',
    url: '/ec-pc-api/common/report/task/Info',
  },
  //店铺活动图上传-报表列表
  storeDecorationActivityUploadTaskList: {
    type: 'post',
    url: '/ec-goods-new-api/storeDecoration/activityUpload/taskList',
  },
  //店铺活动图上传-上传
  storeDecorationActivityUpload: {
    type: 'post',
    url: '/ec-pc-api/store/decoration/import/storeDecorationImport',
  },
  // 店铺活动图上传-贴图上传
  storeDecorationStickerUpload: {
    type: 'post',
    url: '/qu-file-upload-api/joyFile/upload',
  },
  //店铺装修模板配置-列表
  storeDecorationTemplateConfigList: {
    type: 'post',
    url: '/ec-pc-api/store/decoration/list',
  },
  //店铺装修模板配置-详情
  storeDecorationTemplateConfigDetail: {
    type: 'get',
    url: '/ec-pc-api/store/decoration/get',
  },
  //店铺装修模板配置-新增
  storeDecorationTemplateConfigAdd: {
    type: 'post',
    url: '/ec-pc-api/store/decoration/add',
  },
  //店铺装修模板配置-更新
  storeDecorationTemplateConfigUpdate: {
    type: 'post',
    url: '/ec-pc-api/store/decoration/update',
  },
  //店铺装修模板配置-删除
  storeDecorationTemplateConfigDelete: {
    type: 'get',
    url: '/ec-pc-api/store/decoration/delete',
  },
}

export default {...newProduct, ...lsyApi, ...samplePicturesImport, ...productModel};
